import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-fa12f9c0"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "ours-main"
};
const _hoisted_2 = {
  class: "ours-swiper"
};
const _hoisted_3 = {
  class: "swiper-container"
};
const _hoisted_4 = {
  class: "swiper-wrapper"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "teachInfo"
};
const _hoisted_7 = {
  class: "teacher_name"
};
const _hoisted_8 = {
  class: "organ_name"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.teacherList, item => {
    return _openBlock(), _createElementBlock("div", {
      key: item.id,
      class: "swiper-slide"
    }, [_createElementVNode("img", {
      src: item.teacher_avatar_url || require('@/assets/images/common/teacher_icon.png')
    }, null, 8, _hoisted_5), _createElementVNode("div", _hoisted_6, [_createElementVNode("p", _hoisted_7, _toDisplayString(item.teacher_name), 1), _createElementVNode("p", _hoisted_8, _toDisplayString(item.organ_name), 1)])]);
  }), 128))])])])]);
}